import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { BaseLayoutColSpanInput } from '@framework/engine/schema/widgets/repository/common/BaseLayoutColSpanInput.tsx';
import { CommonGraphicWidgetConfigSchema } from '@framework/engine/schema/widgets/repository/graphics/common/CommonGraphicWidgetConfigSchema.ts';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { RadioGroupInput } from '@framework/form/inputs/RadioGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { type IImageWidget, WidgetImageType } from './IImageWidget.ts';
import { ImageUploadInput } from './ImageUploadInput.tsx';

export const ImageWidgetConfigSchema: yup.ObjectSchema<IImageWidget> =
  CommonGraphicWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetImageType).required(),
    imageId: yup.string().nullable().optional().label('Immagine'),
    alignment: yup
      .string()
      .nullable()
      .oneOf(['left', 'center', 'right', null])
      .optional()
      .default('left')
      .label('Allineamento'),
    maxWidth: yup
      .number()
      .nullable()
      .positive()
      .integer()
      .optional()
      .label('Larghezza massima'),
    maxHeight: yup
      .number()
      .nullable()
      .positive()
      .integer()
      .optional()
      .label('Altezza massima'),
  });

export interface IImageWidgetConfigComponentProps
  extends IWidgetComponentProps<IImageWidget> {}

export function ImageWidgetConfigComponent(
  props: IImageWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />

      <FormItem name="imageId" label="Immagine">
        <ImageUploadInput name="imageId" />
      </FormItem>

      <FormItem name="alignment" label="Allineamento">
        <RadioGroupInput
          name="alignment"
          options={[
            { label: 'Sinistra', value: 'left' },
            { label: 'Centro', value: 'center' },
            { label: 'Destra', value: 'right' },
          ]}
        />
      </FormItem>

      <RowElement>
        <FormItem name="maxWidth" label="Larghezza massima">
          <NumberInput
            name="maxWidth"
            placeholder="100%"
            addonAfter="px"
            min={1}
          />
        </FormItem>

        <FormItem name="maxHeight" label="Altezza massima">
          <NumberInput
            name="maxHeight"
            placeholder="auto"
            addonAfter="px"
            min={1}
          />
        </FormItem>
      </RowElement>
    </div>
  );
}
